import { Skeleton } from "@/components/ui/skeleton";

export function TimelineItemSkeleton() {
  return (
    <div className="relative flex flex-row gap-4 pb-8">
      {/* Timeline dot and line */}
      <div className="relative flex flex-col items-center">
        <Skeleton className="w-4 h-4 rounded-full flex-shrink-0" />
        <div className="w-0.5 h-full bg-gray-700 mt-2" />
      </div>

      {/* Content */}
      <div className="flex-1 pt-0">
        <Skeleton className="h-3 w-24 mb-2" />
        <Skeleton className="h-6 w-48 mb-2" />
        <Skeleton className="h-4 w-full mb-1" />
        <Skeleton className="h-4 w-3/4" />
      </div>
    </div>
  );
}

export function TimelineSkeleton({ count = 4 }: { count?: number }) {
  return (
    <div className="w-full">
      {/* Header */}
      <div className="mb-8">
        <Skeleton className="h-8 w-32 mb-2" />
        <Skeleton className="h-4 w-56" />
      </div>

      {/* Timeline container */}
      <div className="bg-backgroundGray rounded-2xl p-6">
        {Array.from({ length: count }).map((_, i) => (
          <TimelineItemSkeleton key={i} />
        ))}
      </div>
    </div>
  );
}
